import { DEFAULT_LOCALE, PAGES } from '@/lib/config';

export type ErrorLayoutProps = {
  title?: Nullable<string>;
  message?: Nullable<string>;
};

if (!global.setImmediate) {
  global.setImmediate = setTimeout as unknown as typeof setImmediate;
}

export default function ErrorLayout({ title, message }: ErrorLayoutProps) {
  return (
    <div className="font-regular flex flex-col items-start max-w-[1440px] py-9 md:py-[58px] lg:py-[72px] px-6">
      <p className="text-[40px] md:text-[60px] lg:text-[74px] font-bulky font-black">{title}</p>
      <p className="text-[16px] lg:text-[20px] font-regular">{message}</p>
      <a href={`/${DEFAULT_LOCALE}${PAGES.TEAM_SELECTION}`} className="btn-link mt-6">
        Go back to the homepage
      </a>
    </div>
  );
}
